import { Container, Row } from "react-bootstrap";
import { ToastContainer, Bounce } from "react-toastify";

import { useHomeContext } from "./HomeView.context.tsx";

const HomeViewUI: React.FC = () => {
  const { renderView, sideBar, modals } = useHomeContext();

  return (
    <>
      <Container fluid className="p-0 m-0" style={{ height: "100vh" }}>
        <Row className="g-0">
          {sideBar}
          {renderView()}
        </Row>
      </Container>

      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        transition={Bounce}
      />

      {modals}
    </>
  );
};

export default HomeViewUI;
